import EmptyState from '@components/EmptyState'
import React from 'react'

const BlockScheduling: React.FC<{
  top?: 'xxxs' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'
  onProceed?: Function
}> = ({ top, onProceed }) => (
  <EmptyState
    heading="Schedule lessons has been temporarily disabled."
    bodyTxt="Please contact your learning center for more information, or raise a case using the button below."
    img="/images/locked.svg"
    linkUrl="/support/contact-us/?id=payments"
    btnTxt="Raise a case"
    top={top}
    onProceed={onProceed}
  />
)

export default BlockScheduling
